import { useState } from "react";
import type { Workshop } from "@/content/workshops";
import { briefByWorkshop } from "@/features/workshop/content";
import {
  clearEffectiveOverrideField,
  setEffectiveOverride,
  useEffectiveWorkshopOverride,
} from "@/stores/useEffectiveWorkshopOverride";
import { Field, SectionFrame, TextInput } from "../editor-kit";

/** Intro-video URL editor — a single link. */
export function IntroVideoEditor({ wsId }: { wsId: Workshop["id"] }) {
  const override = useEffectiveWorkshopOverride(wsId);
  const authored =
    briefByWorkshop[wsId]?.find((r) => r.id === "intro-video")?.videoUrl ?? "";
  const current = override?.introVideoUrl ?? authored;
  const [draft, setDraft] = useState(current);

  return (
    <SectionFrame
      description="The intro-video link opened from the Brief panel."
      overridden={override?.introVideoUrl !== undefined}
      dirty={draft !== current}
      onSave={() => setEffectiveOverride(wsId, { introVideoUrl: draft })}
      onReset={() => {
        clearEffectiveOverrideField(wsId, "introVideoUrl");
        setDraft(authored);
      }}
    >
      <Field
        label="Intro video URL"
        hint="Opens in a new tab. Leave blank to fall back to the default link."
      >
        <TextInput
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="https://..."
        />
      </Field>
    </SectionFrame>
  );
}
